import { process } from './process';
import { global } from './global';
import { queueResizeObserver } from './queueResizeObserver';
var watching = 0;
var isWatching = function () { return !!watching; };
var CATCH_FRAMES = 60 / 5; // Fifth of a second
var observerConfig = { attributes: true, characterData: true, childList: true, subtree: true };
var events = [
    // Global Resize
    'resize',
    // Global Load
    'load',
    // Transitions & Animations
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    // Interactions
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var scheduled = false;
var Scheduler = /** @class */ (function () {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function () { return _this.schedule(); };
    }
    Scheduler.prototype.run = function (frames) {
        var _this = this;
        if (scheduled) {
            return;
        }
        scheduled = true;
        queueResizeObserver(function () {
            var elementsHaveResized = false;
            try {
                // Process Calculations
                elementsHaveResized = process();
            }
            finally {
                scheduled = false;
                if (!isWatching()) {
                    return;
                }
                // Have any changes happened?
                if (elementsHaveResized) {
                    _this.run(60);
                }
                // Should we continue to check?
                else if (frames) {
                    _this.run(frames - 1);
                }
                // Start listening again
                else {
                    _this.start();
                }
            }
        });
    };
    Scheduler.prototype.schedule = function () {
        this.stop(); // Stop listening
        this.run(CATCH_FRAMES); // Run schedule
    };
    Scheduler.prototype.observe = function () {
        var _this = this;
        var cb = function () { return _this.observer && _this.observer.observe(document.body, observerConfig); };
        /* istanbul ignore next */
        document.body ? cb() : global.addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function () {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            events.forEach(function (name) { return global.addEventListener(name, _this.listener, true); });
        }
    };
    Scheduler.prototype.stop = function () {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            events.forEach(function (name) { return global.removeEventListener(name, _this.listener, true); });
            this.stopped = true;
        }
    };
    return Scheduler;
}());
var scheduler = new Scheduler();
var updateCount = function (n) {
    !watching && n > 0 && scheduler.start();
    watching += n;
    !watching && scheduler.stop();
};
export { scheduler, updateCount };
